export class ConfigurationAccessory {
  constructor(id: number) {
    this.accessoryId = id;
  }

  accessoryId: number;
}
